<template>
  <div class="room-call-new-window-component">
    <div class="room-call-new-window" 
         :class="{ 'isOpen': isOpen }">
      <transition-group name="fade" class="room-call-new-window-transition">
        <div 
            v-if="!isOpen" class="room-call-new-window-contents" key="open-new-window">
          <button class="room-call-new-window-button open" @click="onOpen"></button>
          <p class="room-call-new-window-text new-window">{{ $t("call.newWindow.title") }}</p>
        </div>
        <div 
            v-else class="room-call-new-window-contents" key="close-new-window">
          <p class="room-call-new-window-text playing">{{ $t("call.newWindow.playing") }}</p>
          <button class="room-call-new-window-button close" 
                  @click="onClose">{{ $t("call.newWindow.quit") }}</button>
        </div>
      </transition-group>
    </div>

    <RoomWindowOpen
        ref="pipVideo"
        :title="'[Gooroomee-PIP]'"
        :width="640"
        :height="360"
        @close="toggle"
    >
        <RoomCallMixing
            :secondVideo="isRoomMode(['screenShare'])"
            :video-only="true"
        />
    </RoomWindowOpen>
  </div>
</template>

<script>
import RoomWindowOpen from "@/components/Room/Window/RoomWindowOpen";
import RoomCallMixing from "@/components/Room/Call/mixing/RoomCallMixing";
import {mapGetters} from "vuex";

export default {
  name: 'RoomCallNewWindow',
  components: {
    RoomCallMixing,
    RoomWindowOpen
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    ...mapGetters('room', ['isRoomMode']),
  },
  created() {
    window.addEventListener('unload', e => {
      this.onClose()
    })
  },
  methods: {
    onOpen() {
      this.$refs.pipVideo.openWindow();
      this.toggle()
    },
    onClose() {
      this.$refs.pipVideo.closeWindow()
    },
    toggle() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style lang="scss" scoped>
.room-call-new-window-component {
  position: absolute;
  inset: 0;
  z-index: 1;
}
.room-call-new-window {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.2s ease-out;
  //&.isOpen {
  //  background: linear-gradient(60deg, #142135 30%, #6f7792);
  //  opacity: 1;
  //}
  &:hover {
    opacity: 1;
  }
}
.room-call-new-window-transition {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
}
.room-call-new-window-contents {
  width: max-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px 0;
  position: absolute;
}
.room-call-new-window-button {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s ease-out;
  &.open {
    width: 60px;
    height: 60px;
    border: 1px solid #fff;
    border-radius: 100%;
    &::before {
      content: '';
      width: 24px;
      height: 24px;
      background: url('~@/assets/images/new_window_white.svg') no-repeat center center / 100% auto;
      display: block;
      transition: 0.2s ease-out;
    }
    &:hover {
      background-color: #fff;
      &::before {
        background: url('~@/assets/images/new_window.svg') no-repeat center center / 24px auto;
      }
    }
  }
  &.close {
    border-radius: 4px;
    padding: 0 24px;
    background: rgba(255, 255, 255, 0.2);
    font-size: 14px;
    color: #fff;
    line-height: 34px;
    &:hover {
      background-color: #fff;
      color: #333;
    }
  }
}
.room-call-new-window-text {
  font-weight: 700;
  color: #fff;
  cursor: default;
  .isOpen {
    font-size: 14px;
  }
  .playing {
    font-size: 16px;
  }
}
</style>